import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import SendingModalWrapper from '../sendingModalWrapper/SendingModalWrapper';
import {TState} from '../../../../redux/store.type';
import {TabType} from '../../types';
import {buyMailingPackage} from '../../../../redux/mailing/mailingActions';
import * as css from '../sendingModalWrapper/SendingModalWrapper.css';
import PackageCard from '../../../packageCard/PackageCard';
import {getStaticImage} from '../../../../globalVariables/GlobalVariables';
import {mailingBank} from '../../icons/images';
import {calculateAmounts} from '../../services/calculateAmounts';
import {TShow} from '../../../prompotionPopup/PromotionPopup';
import setGlobalState from '../../../../redux/setGlobalState';

function PackageSelectionModal({show, currentTab}: {show: TShow; currentTab: TabType;}) {
    const {t} = useTranslation('mailing');
    const account = useSelector((state: TState) => state.account);
    const billPackage = useSelector((state: TState) => state.account.billPackage);
    const {amountLeft, total} = calculateAmounts(currentTab, billPackage);
    const [selectedPackage, setSelectedPackage] = useState<number | null>(parseInt((account?.mailingPackage as any)?.mpid) || null);
    const image = getStaticImage(mailingBank);

    const handleUpgrade = () => {
        if(selectedPackage) {
            buyMailingPackage(selectedPackage).then((res) => {
                if(res === true){
                    setGlobalState('ui.show.isOpenPackageSuccess', true);
                }
            });
        }
        show.close();
    };

    const buttons = {
        whiteBtn: {text: 'close', onClick: show.close},
        blueBtn: {text: t('upgradeNow'), onClick: handleUpgrade, disabled: !selectedPackage}
    };

    const packages = (account as any).mailingPackageList?.map((mailingPackage: any) => ({
        id: mailingPackage.mpid,
        name: mailingPackage.title,
        price: mailingPackage.price,
        emailMessages: mailingPackage.amountEmail,
        smsMessages: mailingPackage.amountSms
    })) || [];

    return (
        <css.packageSelectionModalContainer>
            <SendingModalWrapper
                show={show}
                title={t('mailingBank')}
                buttons={buttons}
                dataCy="packageSelectionModal"
                headerImage={image}
                headerHeight="short"
            >
                <css.messageText>
                    <css.messageLine>{t(`${currentTab}Left`, {count: amountLeft, total: total})}</css.messageLine>
                    <css.messageLine>{t('upgradeEasily')}</css.messageLine>
                    <css.messageLine>{t('unbeatablePrices')}</css.messageLine>
                </css.messageText>
                <css.packagesContainer>
                    {packages.map((pkg) => (
                        <PackageCard
                            key={pkg.id}
                            packageData={pkg}
                            onClick={() => setSelectedPackage(pkg.id)}
                            isSelected={selectedPackage === pkg.id}
                        />
                    ))}
                </css.packagesContainer>
            </SendingModalWrapper>
        </css.packageSelectionModalContainer>
    );
}

export default PackageSelectionModal;
